<template>
  <div class="xh-header-wrap">
     <!--PC头部 start-->
    <div class="pc-header">
      <div class="header-wrap">
        <div class="logo">
          <a href="/"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/logo.png" width="100%" /></a>
        </div>
        <ul class="header-box">
          <el-row>
            <template v-for="(item,index) in navLists">
             <el-col :xs="6" :sm="6" :lg="3" @click="routerLink(index, item.path)"> <router-link :to="item.path"  :class="navIndex === index ? 'hover' : ''">{{item.text}}</router-link></el-col>
            </template>
             <el-col :xs="6" :sm="6" :lg="3"> <a href="javascript:;">清洁服务</a></el-col>
             <el-col :xs="6" :sm="6" :lg="3"> <a href="javascript:;">洁满仓商城</a></el-col>

          </el-row>
        </ul>
      </div>
    </div>
    <!--PC头部 end-->
    <!--手机版头部 start-->
    <div class="mobile-header" id="headerFixed" :class="topFixed == true ? 'isFixed' :''">
      <div class="m-box">
        <el-row>
          <el-col :xs="12" :lg="12">
            <div class="m-logo">
              <a href="/"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/logo.png" width="100%" /></a>
            </div>
          </el-col>
          <el-col :xs="12" :lg="12">
            <div class="m-menu" @click="drawer = true">
              <i><svg-icon class="menu" icon-class="menu"></svg-icon></i>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-drawer class="m-el-drawer" :visible.sync="drawer" :direction="direction"  size="70%">
      <ul class="menu-box">
        <template v-for="(item,index) in navLists">
          <li><a :href="item.path">{{item.text}}</a></li>
        </template>
          <li><a href="https://www.xinyujia.com.cn" target="_blank">清洁服务</a></li>
          <li><a href="http://www.jiemancang.com" target="_blank">洁满仓商城</a></li>

      </ul>
    </el-drawer>
    <!--手机版头部 end-->
  </div>
</template>

<script>
  export default {
      data() {
        return {
          drawer: false,
          direction: 'ltr',
          topFixed:false,
          navLists:[
                  {
                      "text":"首页",
                      "path":"/"
                  },
                  {
                      "text":"课程",
                      "path":"/coursesIndex"
                  },
                  {
                      "text":"师资",
                      "path":"/cleanExpert"
                  },
                  {
                      "text":"教材",
                      "path":"/teachingMaterial/12"
                  },
                  {
                      "text":"招商合作",
                      "path":"/attractInvestment"
                  },
                  {
                      "text":"关于弘范",
                      "path":"/aboutUs"
                  }
            ],
           navIndex: 0,
        };
      },
      watch: {

      },
      methods: {
            routerLink(index, path) {
             // 点击哪个路由就赋值给自定义的下标
             this.navIndex = index;
             // 路由跳转
             this.$router.push(path)
           },
           handleScroll () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                var offsetTop = document.querySelector('#headerFixed').offsetTop
                if (scrollTop > offsetTop) {
                this.topFixed = true
                } else {
                this.topFixed = false
                }
              },
              destroyed () {
                window.removeEventListener('scroll', this.handleScroll)
              }



      },
      mounted () {
      window.addEventListener('scroll', this.handleScroll)
      },
    };
</script>

<style lang="scss">
@import '../../assets/css/common.scss';
@import '../../assets/font/font.css';
@import '../../assets/css/header.scss';
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue